import { render, staticRenderFns } from "./MemoriaCapacitacao.vue?vue&type=template&id=e8c1991c&scoped=true"
import script from "./MemoriaCapacitacao.vue?vue&type=script&lang=js"
export * from "./MemoriaCapacitacao.vue?vue&type=script&lang=js"
import style0 from "./MemoriaCapacitacao.vue?vue&type=style&index=0&id=e8c1991c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c1991c",
  null
  
)

export default component.exports